import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.lenses.snappable";
export interface EncryptionData {
    key: Uint8Array;
    ivStore: {
        [key: string]: Uint8Array;
    };
    isKeyServerEncrypted: boolean;
    isKeyE2eEncrypted: boolean;
    encryptionScheme: EncryptionData_EncryptionScheme;
}
export enum EncryptionData_EncryptionScheme {
    NOT_APPLICABLE = "NOT_APPLICABLE",
    SPOOKEY = "SPOOKEY",
    REGISTRY = "REGISTRY",
    FIDELIUS = "FIDELIUS",
    UNRECOGNIZED = "UNRECOGNIZED"
}
export function encryptionData_EncryptionSchemeFromJSON(object: any): EncryptionData_EncryptionScheme {
    switch (object) {
        case 0:
        case "NOT_APPLICABLE":
            return EncryptionData_EncryptionScheme.NOT_APPLICABLE;
        case 1:
        case "SPOOKEY":
            return EncryptionData_EncryptionScheme.SPOOKEY;
        case 2:
        case "REGISTRY":
            return EncryptionData_EncryptionScheme.REGISTRY;
        case 3:
        case "FIDELIUS":
            return EncryptionData_EncryptionScheme.FIDELIUS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return EncryptionData_EncryptionScheme.UNRECOGNIZED;
    }
}
export function encryptionData_EncryptionSchemeToNumber(object: EncryptionData_EncryptionScheme): number {
    switch (object) {
        case EncryptionData_EncryptionScheme.NOT_APPLICABLE:
            return 0;
        case EncryptionData_EncryptionScheme.SPOOKEY:
            return 1;
        case EncryptionData_EncryptionScheme.REGISTRY:
            return 2;
        case EncryptionData_EncryptionScheme.FIDELIUS:
            return 3;
        case EncryptionData_EncryptionScheme.UNRECOGNIZED:
        default:
            return -1;
    }
}
export interface EncryptionData_IvStoreEntry {
    key: string;
    value: Uint8Array;
}
export interface PlayerData {
    store: {
        [key: string]: string;
    };
    serializedStore: Uint8Array;
}
export interface PlayerData_StoreEntry {
    key: string;
    value: string;
}
export interface SessionData {
    playerData: {
        [key: string]: PlayerData;
    };
}
export interface SessionData_PlayerDataEntry {
    key: string;
    value: PlayerData | undefined;
}
export interface SnappableMedia {
    sessionId: string;
    playerId: string;
    url: string;
    key: string;
    createdTime: string;
}
export interface Snap3DData {
    allowZippedMedia: boolean;
}
export interface UsesCameraRoll {
    usesCameraRoll: boolean;
}
export interface SnappableMessage {
    snappable: Snappable | undefined;
    media: SnappableMedia[];
    effectId: string;
    userIds: string[];
    focusPointX: number;
    focusPointY: number;
    focusPointWidth: number;
    replyType: SnappableMessage_ReplyType;
    snap3dData: Snap3DData | undefined;
    usesCameraRollData: UsesCameraRoll | undefined;
    assetBatchId: string;
}
export enum SnappableMessage_ReplyType {
    NOT_APPLICABLE = "NOT_APPLICABLE",
    CONTEXT = "CONTEXT",
    INTERSTITIAL = "INTERSTITIAL",
    UNRECOGNIZED = "UNRECOGNIZED"
}
export function snappableMessage_ReplyTypeFromJSON(object: any): SnappableMessage_ReplyType {
    switch (object) {
        case 0:
        case "NOT_APPLICABLE":
            return SnappableMessage_ReplyType.NOT_APPLICABLE;
        case 1:
        case "CONTEXT":
            return SnappableMessage_ReplyType.CONTEXT;
        case 2:
        case "INTERSTITIAL":
            return SnappableMessage_ReplyType.INTERSTITIAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SnappableMessage_ReplyType.UNRECOGNIZED;
    }
}
export function snappableMessage_ReplyTypeToNumber(object: SnappableMessage_ReplyType): number {
    switch (object) {
        case SnappableMessage_ReplyType.NOT_APPLICABLE:
            return 0;
        case SnappableMessage_ReplyType.CONTEXT:
            return 1;
        case SnappableMessage_ReplyType.INTERSTITIAL:
            return 2;
        case SnappableMessage_ReplyType.UNRECOGNIZED:
        default:
            return -1;
    }
}
export interface Snappable {
    id: string;
    sessionId: string;
    playerId: string;
    sessionData: SessionData | undefined;
    createdTime: string;
    expireTime: string;
    version: number;
    encryptionData: EncryptionData | undefined;
    sessionDepth: number;
}
export interface PutSnappableRequest {
    snappable: Snappable | undefined;
    media: SnappableMedia[];
}
export interface PutSnappableResponse {
    id: string;
}
export interface GetSnappableRequest {
    id: string;
}
export interface GetSnappableResponse {
    data: Snappable | undefined;
    media: SnappableMedia[];
}
export interface SnappableEncryptedKey {
    encryptedKey: Uint8Array;
    encryptionKeyId: string;
    encryptionKeyIv: Uint8Array;
}
function createBaseEncryptionData(): EncryptionData {
    return {
        key: new Uint8Array(0),
        ivStore: {},
        isKeyServerEncrypted: false,
        isKeyE2eEncrypted: false,
        encryptionScheme: EncryptionData_EncryptionScheme.NOT_APPLICABLE,
    };
}
export const EncryptionData: MessageFns<EncryptionData> = {
    encode(message: EncryptionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        Object.entries(message.ivStore).forEach(([key, value]) => {
            EncryptionData_IvStoreEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
        });
        if (message.isKeyServerEncrypted !== false) {
            writer.uint32(24).bool(message.isKeyServerEncrypted);
        }
        if (message.isKeyE2eEncrypted !== false) {
            writer.uint32(32).bool(message.isKeyE2eEncrypted);
        }
        if (message.encryptionScheme !== EncryptionData_EncryptionScheme.NOT_APPLICABLE) {
            writer.uint32(40).int32(encryptionData_EncryptionSchemeToNumber(message.encryptionScheme));
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): EncryptionData {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEncryptionData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.bytes();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = EncryptionData_IvStoreEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.ivStore[entry2.key] = entry2.value;
                    }
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.isKeyServerEncrypted = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.isKeyE2eEncrypted = reader.bool();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.encryptionScheme = encryptionData_EncryptionSchemeFromJSON(reader.int32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<EncryptionData>, I>>(base?: I): EncryptionData {
        return EncryptionData.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<EncryptionData>, I>>(object: I): EncryptionData {
        const message = createBaseEncryptionData();
        message.key = object.key ?? new Uint8Array(0);
        message.ivStore = Object.entries(object.ivStore ?? {}).reduce<{
            [key: string]: Uint8Array;
        }>((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = value;
            }
            return acc;
        }, {});
        message.isKeyServerEncrypted = object.isKeyServerEncrypted ?? false;
        message.isKeyE2eEncrypted = object.isKeyE2eEncrypted ?? false;
        message.encryptionScheme = object.encryptionScheme ?? EncryptionData_EncryptionScheme.NOT_APPLICABLE;
        return message;
    },
};
function createBaseEncryptionData_IvStoreEntry(): EncryptionData_IvStoreEntry {
    return { key: "", value: new Uint8Array(0) };
}
export const EncryptionData_IvStoreEntry: MessageFns<EncryptionData_IvStoreEntry> = {
    encode(message: EncryptionData_IvStoreEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value.length !== 0) {
            writer.uint32(18).bytes(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): EncryptionData_IvStoreEntry {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEncryptionData_IvStoreEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<EncryptionData_IvStoreEntry>, I>>(base?: I): EncryptionData_IvStoreEntry {
        return EncryptionData_IvStoreEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<EncryptionData_IvStoreEntry>, I>>(object: I): EncryptionData_IvStoreEntry {
        const message = createBaseEncryptionData_IvStoreEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? new Uint8Array(0);
        return message;
    },
};
function createBasePlayerData(): PlayerData {
    return { store: {}, serializedStore: new Uint8Array(0) };
}
export const PlayerData: MessageFns<PlayerData> = {
    encode(message: PlayerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        Object.entries(message.store).forEach(([key, value]) => {
            PlayerData_StoreEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
        });
        if (message.serializedStore.length !== 0) {
            writer.uint32(18).bytes(message.serializedStore);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): PlayerData {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = PlayerData_StoreEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.store[entry1.key] = entry1.value;
                    }
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.serializedStore = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<PlayerData>, I>>(base?: I): PlayerData {
        return PlayerData.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PlayerData>, I>>(object: I): PlayerData {
        const message = createBasePlayerData();
        message.store = Object.entries(object.store ?? {}).reduce<{
            [key: string]: string;
        }>((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        message.serializedStore = object.serializedStore ?? new Uint8Array(0);
        return message;
    },
};
function createBasePlayerData_StoreEntry(): PlayerData_StoreEntry {
    return { key: "", value: "" };
}
export const PlayerData_StoreEntry: MessageFns<PlayerData_StoreEntry> = {
    encode(message: PlayerData_StoreEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): PlayerData_StoreEntry {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerData_StoreEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<PlayerData_StoreEntry>, I>>(base?: I): PlayerData_StoreEntry {
        return PlayerData_StoreEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PlayerData_StoreEntry>, I>>(object: I): PlayerData_StoreEntry {
        const message = createBasePlayerData_StoreEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseSessionData(): SessionData {
    return { playerData: {} };
}
export const SessionData: MessageFns<SessionData> = {
    encode(message: SessionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        Object.entries(message.playerData).forEach(([key, value]) => {
            SessionData_PlayerDataEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
        });
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SessionData {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSessionData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = SessionData_PlayerDataEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.playerData[entry1.key] = entry1.value;
                    }
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SessionData>, I>>(base?: I): SessionData {
        return SessionData.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SessionData>, I>>(object: I): SessionData {
        const message = createBaseSessionData();
        message.playerData = Object.entries(object.playerData ?? {}).reduce<{
            [key: string]: PlayerData;
        }>((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = PlayerData.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseSessionData_PlayerDataEntry(): SessionData_PlayerDataEntry {
    return { key: "", value: undefined };
}
export const SessionData_PlayerDataEntry: MessageFns<SessionData_PlayerDataEntry> = {
    encode(message: SessionData_PlayerDataEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            PlayerData.encode(message.value, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SessionData_PlayerDataEntry {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSessionData_PlayerDataEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = PlayerData.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SessionData_PlayerDataEntry>, I>>(base?: I): SessionData_PlayerDataEntry {
        return SessionData_PlayerDataEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SessionData_PlayerDataEntry>, I>>(object: I): SessionData_PlayerDataEntry {
        const message = createBaseSessionData_PlayerDataEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? PlayerData.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseSnappableMedia(): SnappableMedia {
    return { sessionId: "", playerId: "", url: "", key: "", createdTime: "0" };
}
export const SnappableMedia: MessageFns<SnappableMedia> = {
    encode(message: SnappableMedia, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.sessionId !== "") {
            writer.uint32(10).string(message.sessionId);
        }
        if (message.playerId !== "") {
            writer.uint32(18).string(message.playerId);
        }
        if (message.url !== "") {
            writer.uint32(26).string(message.url);
        }
        if (message.key !== "") {
            writer.uint32(34).string(message.key);
        }
        if (message.createdTime !== "0") {
            writer.uint32(40).int64(message.createdTime);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SnappableMedia {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnappableMedia();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.sessionId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.playerId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.createdTime = reader.int64().toString();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SnappableMedia>, I>>(base?: I): SnappableMedia {
        return SnappableMedia.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SnappableMedia>, I>>(object: I): SnappableMedia {
        const message = createBaseSnappableMedia();
        message.sessionId = object.sessionId ?? "";
        message.playerId = object.playerId ?? "";
        message.url = object.url ?? "";
        message.key = object.key ?? "";
        message.createdTime = object.createdTime ?? "0";
        return message;
    },
};
function createBaseSnap3DData(): Snap3DData {
    return { allowZippedMedia: false };
}
export const Snap3DData: MessageFns<Snap3DData> = {
    encode(message: Snap3DData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.allowZippedMedia !== false) {
            writer.uint32(8).bool(message.allowZippedMedia);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): Snap3DData {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnap3DData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.allowZippedMedia = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<Snap3DData>, I>>(base?: I): Snap3DData {
        return Snap3DData.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<Snap3DData>, I>>(object: I): Snap3DData {
        const message = createBaseSnap3DData();
        message.allowZippedMedia = object.allowZippedMedia ?? false;
        return message;
    },
};
function createBaseUsesCameraRoll(): UsesCameraRoll {
    return { usesCameraRoll: false };
}
export const UsesCameraRoll: MessageFns<UsesCameraRoll> = {
    encode(message: UsesCameraRoll, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.usesCameraRoll !== false) {
            writer.uint32(8).bool(message.usesCameraRoll);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): UsesCameraRoll {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUsesCameraRoll();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.usesCameraRoll = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<UsesCameraRoll>, I>>(base?: I): UsesCameraRoll {
        return UsesCameraRoll.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<UsesCameraRoll>, I>>(object: I): UsesCameraRoll {
        const message = createBaseUsesCameraRoll();
        message.usesCameraRoll = object.usesCameraRoll ?? false;
        return message;
    },
};
function createBaseSnappableMessage(): SnappableMessage {
    return {
        snappable: undefined,
        media: [],
        effectId: "",
        userIds: [],
        focusPointX: 0,
        focusPointY: 0,
        focusPointWidth: 0,
        replyType: SnappableMessage_ReplyType.NOT_APPLICABLE,
        snap3dData: undefined,
        usesCameraRollData: undefined,
        assetBatchId: "",
    };
}
export const SnappableMessage: MessageFns<SnappableMessage> = {
    encode(message: SnappableMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.snappable !== undefined) {
            Snappable.encode(message.snappable, writer.uint32(10).fork()).join();
        }
        for (const v of message.media) {
            SnappableMedia.encode(v!, writer.uint32(18).fork()).join();
        }
        if (message.effectId !== "") {
            writer.uint32(26).string(message.effectId);
        }
        for (const v of message.userIds) {
            writer.uint32(34).string(v!);
        }
        if (message.focusPointX !== 0) {
            writer.uint32(45).float(message.focusPointX);
        }
        if (message.focusPointY !== 0) {
            writer.uint32(53).float(message.focusPointY);
        }
        if (message.focusPointWidth !== 0) {
            writer.uint32(61).float(message.focusPointWidth);
        }
        if (message.replyType !== SnappableMessage_ReplyType.NOT_APPLICABLE) {
            writer.uint32(64).int32(snappableMessage_ReplyTypeToNumber(message.replyType));
        }
        if (message.snap3dData !== undefined) {
            Snap3DData.encode(message.snap3dData, writer.uint32(74).fork()).join();
        }
        if (message.usesCameraRollData !== undefined) {
            UsesCameraRoll.encode(message.usesCameraRollData, writer.uint32(82).fork()).join();
        }
        if (message.assetBatchId !== "") {
            writer.uint32(4002).string(message.assetBatchId);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SnappableMessage {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnappableMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.snappable = Snappable.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.media.push(SnappableMedia.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.effectId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.userIds.push(reader.string());
                    continue;
                }
                case 5: {
                    if (tag !== 45) {
                        break;
                    }
                    message.focusPointX = reader.float();
                    continue;
                }
                case 6: {
                    if (tag !== 53) {
                        break;
                    }
                    message.focusPointY = reader.float();
                    continue;
                }
                case 7: {
                    if (tag !== 61) {
                        break;
                    }
                    message.focusPointWidth = reader.float();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.replyType = snappableMessage_ReplyTypeFromJSON(reader.int32());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.snap3dData = Snap3DData.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.usesCameraRollData = UsesCameraRoll.decode(reader, reader.uint32());
                    continue;
                }
                case 500: {
                    if (tag !== 4002) {
                        break;
                    }
                    message.assetBatchId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SnappableMessage>, I>>(base?: I): SnappableMessage {
        return SnappableMessage.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SnappableMessage>, I>>(object: I): SnappableMessage {
        const message = createBaseSnappableMessage();
        message.snappable = (object.snappable !== undefined && object.snappable !== null)
            ? Snappable.fromPartial(object.snappable)
            : undefined;
        message.media = object.media?.map((e) => SnappableMedia.fromPartial(e)) || [];
        message.effectId = object.effectId ?? "";
        message.userIds = object.userIds?.map((e) => e) || [];
        message.focusPointX = object.focusPointX ?? 0;
        message.focusPointY = object.focusPointY ?? 0;
        message.focusPointWidth = object.focusPointWidth ?? 0;
        message.replyType = object.replyType ?? SnappableMessage_ReplyType.NOT_APPLICABLE;
        message.snap3dData = (object.snap3dData !== undefined && object.snap3dData !== null)
            ? Snap3DData.fromPartial(object.snap3dData)
            : undefined;
        message.usesCameraRollData = (object.usesCameraRollData !== undefined && object.usesCameraRollData !== null)
            ? UsesCameraRoll.fromPartial(object.usesCameraRollData)
            : undefined;
        message.assetBatchId = object.assetBatchId ?? "";
        return message;
    },
};
function createBaseSnappable(): Snappable {
    return {
        id: "",
        sessionId: "",
        playerId: "",
        sessionData: undefined,
        createdTime: "0",
        expireTime: "0",
        version: 0,
        encryptionData: undefined,
        sessionDepth: 0,
    };
}
export const Snappable: MessageFns<Snappable> = {
    encode(message: Snappable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.sessionId !== "") {
            writer.uint32(18).string(message.sessionId);
        }
        if (message.playerId !== "") {
            writer.uint32(26).string(message.playerId);
        }
        if (message.sessionData !== undefined) {
            SessionData.encode(message.sessionData, writer.uint32(34).fork()).join();
        }
        if (message.createdTime !== "0") {
            writer.uint32(40).int64(message.createdTime);
        }
        if (message.expireTime !== "0") {
            writer.uint32(48).int64(message.expireTime);
        }
        if (message.version !== 0) {
            writer.uint32(56).int32(message.version);
        }
        if (message.encryptionData !== undefined) {
            EncryptionData.encode(message.encryptionData, writer.uint32(66).fork()).join();
        }
        if (message.sessionDepth !== 0) {
            writer.uint32(72).int32(message.sessionDepth);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): Snappable {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnappable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.sessionId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.playerId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.sessionData = SessionData.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.createdTime = reader.int64().toString();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.expireTime = reader.int64().toString();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.version = reader.int32();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.encryptionData = EncryptionData.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.sessionDepth = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<Snappable>, I>>(base?: I): Snappable {
        return Snappable.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<Snappable>, I>>(object: I): Snappable {
        const message = createBaseSnappable();
        message.id = object.id ?? "";
        message.sessionId = object.sessionId ?? "";
        message.playerId = object.playerId ?? "";
        message.sessionData = (object.sessionData !== undefined && object.sessionData !== null)
            ? SessionData.fromPartial(object.sessionData)
            : undefined;
        message.createdTime = object.createdTime ?? "0";
        message.expireTime = object.expireTime ?? "0";
        message.version = object.version ?? 0;
        message.encryptionData = (object.encryptionData !== undefined && object.encryptionData !== null)
            ? EncryptionData.fromPartial(object.encryptionData)
            : undefined;
        message.sessionDepth = object.sessionDepth ?? 0;
        return message;
    },
};
function createBasePutSnappableRequest(): PutSnappableRequest {
    return { snappable: undefined, media: [] };
}
export const PutSnappableRequest: MessageFns<PutSnappableRequest> = {
    encode(message: PutSnappableRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.snappable !== undefined) {
            Snappable.encode(message.snappable, writer.uint32(10).fork()).join();
        }
        for (const v of message.media) {
            SnappableMedia.encode(v!, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): PutSnappableRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePutSnappableRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.snappable = Snappable.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.media.push(SnappableMedia.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<PutSnappableRequest>, I>>(base?: I): PutSnappableRequest {
        return PutSnappableRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PutSnappableRequest>, I>>(object: I): PutSnappableRequest {
        const message = createBasePutSnappableRequest();
        message.snappable = (object.snappable !== undefined && object.snappable !== null)
            ? Snappable.fromPartial(object.snappable)
            : undefined;
        message.media = object.media?.map((e) => SnappableMedia.fromPartial(e)) || [];
        return message;
    },
};
function createBasePutSnappableResponse(): PutSnappableResponse {
    return { id: "" };
}
export const PutSnappableResponse: MessageFns<PutSnappableResponse> = {
    encode(message: PutSnappableResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): PutSnappableResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePutSnappableResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<PutSnappableResponse>, I>>(base?: I): PutSnappableResponse {
        return PutSnappableResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PutSnappableResponse>, I>>(object: I): PutSnappableResponse {
        const message = createBasePutSnappableResponse();
        message.id = object.id ?? "";
        return message;
    },
};
function createBaseGetSnappableRequest(): GetSnappableRequest {
    return { id: "" };
}
export const GetSnappableRequest: MessageFns<GetSnappableRequest> = {
    encode(message: GetSnappableRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetSnappableRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetSnappableRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetSnappableRequest>, I>>(base?: I): GetSnappableRequest {
        return GetSnappableRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetSnappableRequest>, I>>(object: I): GetSnappableRequest {
        const message = createBaseGetSnappableRequest();
        message.id = object.id ?? "";
        return message;
    },
};
function createBaseGetSnappableResponse(): GetSnappableResponse {
    return { data: undefined, media: [] };
}
export const GetSnappableResponse: MessageFns<GetSnappableResponse> = {
    encode(message: GetSnappableResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.data !== undefined) {
            Snappable.encode(message.data, writer.uint32(10).fork()).join();
        }
        for (const v of message.media) {
            SnappableMedia.encode(v!, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetSnappableResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetSnappableResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.data = Snappable.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.media.push(SnappableMedia.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetSnappableResponse>, I>>(base?: I): GetSnappableResponse {
        return GetSnappableResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetSnappableResponse>, I>>(object: I): GetSnappableResponse {
        const message = createBaseGetSnappableResponse();
        message.data = (object.data !== undefined && object.data !== null) ? Snappable.fromPartial(object.data) : undefined;
        message.media = object.media?.map((e) => SnappableMedia.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSnappableEncryptedKey(): SnappableEncryptedKey {
    return { encryptedKey: new Uint8Array(0), encryptionKeyId: "", encryptionKeyIv: new Uint8Array(0) };
}
export const SnappableEncryptedKey: MessageFns<SnappableEncryptedKey> = {
    encode(message: SnappableEncryptedKey, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.encryptedKey.length !== 0) {
            writer.uint32(10).bytes(message.encryptedKey);
        }
        if (message.encryptionKeyId !== "") {
            writer.uint32(18).string(message.encryptionKeyId);
        }
        if (message.encryptionKeyIv.length !== 0) {
            writer.uint32(26).bytes(message.encryptionKeyIv);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SnappableEncryptedKey {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnappableEncryptedKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.encryptedKey = reader.bytes();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.encryptionKeyId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.encryptionKeyIv = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SnappableEncryptedKey>, I>>(base?: I): SnappableEncryptedKey {
        return SnappableEncryptedKey.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SnappableEncryptedKey>, I>>(object: I): SnappableEncryptedKey {
        const message = createBaseSnappableEncryptedKey();
        message.encryptedKey = object.encryptedKey ?? new Uint8Array(0);
        message.encryptionKeyId = object.encryptionKeyId ?? "";
        message.encryptionKeyIv = object.encryptionKeyIv ?? new Uint8Array(0);
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {
    $case: string;
} ? {
    [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]>;
} & {
    $case: T["$case"];
} : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
